module.exports = __webpack_public_path__ + "img/barril-historia.63070d91.jpg";